module.exports = __webpack_public_path__ + "static/img/wechat.286fd90e.png";